<template>
  <div>
    <div class="head-nav d-aligncnter">
      <div class="nav-left"></div>
      <div class="nav-title d-allcenter overflow">校外人员场馆预约</div>
      <div class="nav-right d-allcenter" @click="rightClick">
        <!-- <img src="@/assets/img/appointment/headset-one.svg" /> -->
      </div>
    </div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.label"
          :name="item.name"
          v-for="(item, index) in tabList"
          :key="'tab_' + index"
        ></el-tab-pane>
        <!-- <el-tab-pane label="待支付" name="second"></el-tab-pane>
        <el-tab-pane label="退款" name="third"></el-tab-pane>
        <el-tab-pane label="已完成" name="fourth"></el-tab-pane> -->
      </el-tabs>

      <div class="all-box" @scroll="handleScroll" ref="myscroll">
        <div v-if="orderList.length == 0" class="d-allcenter d-column">
          <img src="@/assets/img/appointment/greenempty.svg" />
          <div class="grey">暂无数据</div>
        </div>
        <div class="each-box" v-for="(item, index) in orderList" :key="'orderList_' + index" @click="pageToInfo(item)">
          <div class="d-between">
            <div style="width: 56px; height: 56px; border-radius: 2px; overflow: hidden" class="d-allcenter">
              <el-image style="width: 56px; height: 56px" :src="item.img" fit="cover"></el-image>
              <!-- <img src="@/assets/img/appointment/demo.png" style="width: 100%" /> -->
            </div>
            <div class="d-column" style="width: calc(100% - 70px)">
              <div class="d-between" style="height: 32px">
                <div style="width: calc(100% - 62px)">
                  {{ item.venueName }}-{{ item.areaName }}-{{ item.blockName }}
                </div>
                <div v-if="item.main">
                  ￥<span class="weight">{{ item.price }}</span>
                </div>
                <div
                  v-else
                  style="background: #e6f2ed; color: #339571; border-radius: 16px; padding: 2px 8px; height: 16px"
                  class="d-allcenter fs-xs"
                >
                  受邀
                </div>
              </div>
              <div class="d-between grey" style="margin-top: 8px">
                <div>{{ item.date }} {{ item.time }}</div>
                <!-- <div v-if="!item.payment">{{ item.status }}</div> -->
                <div v-if="item.status == '待支付'">
                  <div
                    class="d-between d-aligncnter"
                    style="border-radius: 12px; background: #e14b4633; color: #e5605a"
                  >
                    <div style="background: #e5605a; color: #fff; border-radius: 12px 0 12px 12px; padding: 2px 4px">
                      等待支付
                    </div>
                    <div style="padding: 2px 4px">{{ getMins(item, index) }}分钟</div>
                  </div>
                </div>
                <div v-else>{{ item.status }}</div>

                <!-- <div>已完成</div> -->
                <!-- <div class="red">已退费</div> -->
                <!-- <div class="red">退费中</div> -->
              </div>
            </div>
          </div>
          <div class="d-end" style="margin-top: 8px; flex-direction: row-reverse">
            <template v-if="item.payment && item.refundFlag">
              <!-- <button size="small" class="plain-btn">详情</button> -->
              <button size="small" class="plain-btn" @click.stop="pagerToCancel(item)" v-if="item.main">
                取消预约
              </button>
              <!-- <button size="small" class="full-btn" @click.stop="inviteFriends(item)">邀请同伴</button> -->
            </template>
            <template v-else-if="!item.payment && item.status == '待支付' && item.main">
              <button size="small" class="full-btn" @click.stop="pageToPay(item)">去支付</button>
              <button size="small" class="plain-btn" @click.stop="cancelOrder(item, index)">取消</button>
            </template>
            <template v-else>
              <!-- <button size="small" class="plain-btn">详情</button> -->
              <button
                size="small"
                class="plain-btn"
                v-if="item.status == '已退款' && item.main"
                @click.stop="pageToRefund(item)"
              >
                钱款去向
              </button>
              <button
                size="small"
                class="plain-btn"
                v-if="(item.status == '已取消' || item.status == '已退款') && item.main"
                @click.stop="delOrderData(item, index)"
              >
                删除订单
              </button>
            </template>
          </div>
        </div>
        <div v-if="orderList.length != 0" class="d-allcenter grey" @click="loadingMore">{{ loadingText }}</div>
      </div>
      <el-dialog title="" :visible.sync="dialogVisible" width="80%" :show-close="false">
        <div class="d-aligncnter d-column">
          <img src="@/assets/img/appointment/headset-two.svg" />
          <span style="margin-top: 32px"
            >拨打电话：<a href="tel:4000-000-000" style="color: #007a4d">4000-000-000</a></span
          >
        </div>

        <div slot="footer" class="dialog-footer d-allcenter" style="width: 100%">
          <button @click="dialogVisible = false" class="dark-btn" round>关闭</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getMyConference, removeConference, removeOrder } from '@/api/api-venueOrder'
import { Message, MessageBox } from 'element-ui'
import EventBus from '@/assets/js/EventBus'
export default {
  data() {
    return {
      activeName: 'first',
      dialogVisible: false,
      page: 1,
      pageSize: 5,
      orderList: [],
      loadingText: '-END-',
      tabList: [
        { name: 'first', label: '全部' },
        { name: 'five', label: '已支付' },
        { name: 'second', label: '待支付' },
        { name: 'third', label: '退款' },
        { name: 'fourth', label: '已完成' },
      ],
      currTab: '全部',
      keepScroll: '',
    }
  },
  mounted() {
    this.getMyConferenceData()
    this.$on('getMyConferenceData', function () {
      console.log('onononon')
      this.page = 1
      this.getMyConferenceData()
    })
    const that = this
    EventBus.$on('refreshOrderList', function () {
      that.page = 1
      that.getMyConferenceData()
    })
    // window.addEventListener('scroll', this.handleScroll)
    this.$on('keepDataOrder', function () {
      this.keepDataOrder()
    })
    setInterval(() => {
      this.$forceUpdate()
    }, 6000)
  },
  beforeDestroy() {
    EventBus.$off('refreshOrderList')
  },
  computed: {
    getMins() {
      return function (item, index) {
        var end = new Date()
        var diff = end.getTime() - item.createTime
        console.log('diff3:', index + '-' + diff)
        if (diff / 1000 > 1800) {
          this.orderList[index].status = '已取消'
        } else {
          return ((1800 - Math.floor(diff / 1000)) / 60).toFixed(0)
        }
      }
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log('eee:', tab, event)
      console.log('eee:', tab.index)
      console.log('eee:', this.tabList[tab.index].label)
      this.currTab = this.tabList[tab.index].label
      this.page = 1
      this.getMyConferenceData()
    },
    rightClick() {
      //   this.dialogVisible = true
    },
    keepDataOrder() {
      console.log('keepDataOrder1:', this.keepScroll)
      this.$refs.myscroll.scrollTop = this.keepScroll
      //   document.body.scrollTop = this.keepScroll
    },
    handleScroll() {
      //   console.log('滚动?', document.documentElement)
      //   console.log('滚动222?', this.$refs.myscroll.scrollTop)
      this.keepScroll = this.$refs.myscroll.scrollTop

      //   console.log('keepDataOrder2:', this.keepScroll)
    },
    cancelOrder(item, index) {
      MessageBox.confirm('确定要取消当前预约吗？', '取消提示', { confirmButtonText: '确定', cancelButtonText: '取消' })
        .then(() => {
          console.log('确定取消')
          const loading = this.$loading({
            lock: true,
            text: '取消预定中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          removeConference(item.conferenceId).then((res) => {
            console.log('取消预约:', res)
            loading.close()
            if (res.data.statusCode == 1) {
              Message.success('已取消')
              //   this.getMyConferenceData()
              this.orderList[index].status = '已取消'
            } else {
              Message.error(res.data.message)
            }
          })
        })
        .catch(() => {
          console.log('取消')
        })
    },
    pageToPay(item) {
      localStorage.setItem('friendlist', [])
      this.$router.push({ path: '/appointment/ordersubmit', query: { conferenceId: item.conferenceId } })
    },
    pageToInfo(item) {
      this.$router.push({ path: '/appointment/orderinfo', query: { conferenceId: item.conferenceId } })
    },
    pagerToCancel(item) {
      this.$router.push({ path: '/appointment/cancelorder', query: { conferenceId: item.conferenceId } })
    },
    getMyConferenceData() {
      const userId = localStorage.getItem('userId')
      getMyConference(this.page, this.pageSize, userId, this.currTab).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res')
          this.orderList = res.data.obj.data
          if (this.orderList.length == res.data.obj.count) {
            this.loadingText = '-END-'
          } else {
            this.loadingText = '加载更多'
          }
        }
      })
    },
    loadingMore() {
      if (this.loadingText == '加载更多') {
        const userId = localStorage.getItem('userId')
        this.page++
        getMyConference(this.page, this.pageSize, userId, this.currTab).then((res) => {
          if (res.data.statusCode == 1) {
            console.log('res')
            this.orderList = [...this.orderList, ...res.data.obj.data]
            if (this.orderList.length == res.data.obj.count) {
              this.loadingText = '-END-'
            } else {
              this.loadingText = '加载更多'
            }
          }
        })
      }
    },
    inviteFriends(item) {
      console.log('item:', item)
    },
    pageToRefund(item) {
      this.$router.push({ path: '/appointment/refund', query: { conferenceId: item.conferenceId } })
    },
    delOrderData(item, index) {
      MessageBox.confirm('确定要删除预约订单吗？删除后不可恢复', '删除提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
      })
        .then(() => {
          removeOrder(item.conferenceId).then((res) => {
            if (res.data.statusCode == 1) {
              Message.success('已删除')
              this.orderList.splice(index, 1)
              //   this.getMyConferenceData()
            } else {
              Message.error(res.data.message)
            }
          })
        })
        .catch(() => {
          console.log('取消')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.model {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 2.801px 8.403px 31.122px -4.046px rgba(22, 52, 80, 0.1);
  margin-top: 16px;
  color: #464646;
}
.mt-16 {
  margin-top: 16px;
}
.venues-each {
  width: 347px;
  height: 192px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  margin: 8px;
  .bg-color {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #002417 0.15%, rgba(0, 122, 77, 0) 54.73%);
  }
  img {
    width: 100%;
  }
}
.venues-info {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 99;
  color: #fff;
  font-size: 14px;
}
.content {
  background: #f9f9f9;
}
.content ::v-deep .el-tabs__item.is-active {
  color: #2f2f2f !important;
  font-weight: 700;
  font-size: 18px;
}
.content ::v-deep .el-tabs__item {
  color: #8b8b8b;
}
.content ::v-deep .el-tabs__active-bar {
  background-color: #1a875f;
}
.all-box {
  height: calc(100vh - 220px);
  overflow: auto;
}
.each-box {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  padding: 16px;
  color: #2f2f2f;
  font-size: 14px;
  margin-bottom: 16px;
}
.plain-btn {
  border: 1px solid #339571;
  color: #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background: #fff;
}
.full-btn {
  background-color: #339571;
  color: #fff;
  border: 1px solid #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.dark-btn {
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%), linear-gradient(270deg, #007a4d 0%, #1a875f 100%);
  border: none;
  height: 36px;
  color: #fff;
  border-radius: 20px;
  padding: 4px 26px;
}
.red {
  color: #e14c46;
}
.el-button:focus,
.el-button:active,
.el-button:hover {
  color: #007a4d;
  border-color: #e6f2ed;
  background-color: #e6f2ed;
}
</style>
